import { render, staticRenderFns } from "./RbmWizard.vue?vue&type=template&id=273fc161&"
import script from "./RbmWizard.vue?vue&type=script&lang=js&"
export * from "./RbmWizard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports